<template>
    <div class="container">
      <div class="row faqs mx-auto mb-5">
        <div class="col-md-12">
          <h1 class="text-uppercase text-center mt-5">
            {{ $t('Receipt_Troubleshooting.Title') }} <!-- Fetching title -->
          </h1>
        <p class="text-center mb-4">
            {{ $t('Receipt_Troubleshooting.Description') }} <!-- Fetching title -->
        </p>
          <div class="accordion" id="faqAccordion">
            <div class="card" v-for="(faq, index) in faqs" :key="index"> <!-- Loop through faqs -->
              <div class="card-header" :id="'heading' + index">
                <h2 class="accordion-header">
                  <button
                    :class="{
                      'arrow-open': activeIndex === index,
                      'arrow-closed': activeIndex !== index,
                    }"
                    class="accordion-button"
                    type="button"
                    @click="toggle(index)"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    :aria-controls="'collapse' + index"
                  >
                    {{ faq.question }} <!-- Fetch question -->
                  </button>
                </h2>
              </div>
                <div
                :id="'collapse' + index"
                class="accordion-collapse collapse"
                :class="{ show: activeIndex === index }"
                :aria-labelledby="'heading' + index"
                data-bs-parent="#faqAccordion"
                role="region"
              >
                <div class="card-body" v-html="faq.answer"></div> <!-- Fetch answer -->
              </div>
            </div>
          </div>
          <h4 class="text-center mt-5 cust-font px-5 mb-5 fw-400"  v-html="$t('Receipt_Troubleshooting.HelpText')">        
        </h4>
        </div>
        <div class="col-md-12 text-center">
        <router-link to="/Home" class="text-uppercase text-center"
          :aria-label="$t('Receipt_Troubleshooting.ReturnHome')">{{ $t('Receipt_Troubleshooting.ReturnHome') }}</router-link
        >
      </div>
      </div>
    </div>
  </template>
  
  <script>
export default {
  name: "FAQ",
  data() {
    return {
      faqs: [], // Initialize empty faqs
      activeIndex: null,
    };
  },
  created() {
    this.loadFaqs(); // Load FAQs when component is created
  },
  watch: {
    "$i18n.locale": "loadFaqs", // Watch for changes in locale
  },
  methods: {
    async loadFaqs() {
      const currentLocale = this.$i18n.locale;
      try {
        const response = await fetch(`/locales/${currentLocale}.json`); // Fetch from public/locales
        const data = await response.json();
        this.faqs = data?.Receipt_Troubleshooting?.faqs || [];
      } catch (error) {
        console.error(`Error loading locale file for ${currentLocale}:`, error);
        this.faqs = []; // Clear FAQs if there's an error
      }
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>
